import Unblock from './unblock';

const unblock = process.env.REACT_APP_BACKEND_URI.replace(/\/+$/, '') + "/api";

const api = {
  unblock: new Unblock(unblock),
};

export default api;
